import { defineStore } from 'pinia'

export const useApiFlagsStore = defineStore('apiFlags', () => {
  const isLogoutInProgress = ref<boolean>(false)
  const isAlertShown = ref<boolean>(false)

  return {
    isLogoutInProgress,
    isAlertShown
  }
})
